import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";
import * as imageConversion from 'image-conversion';

import { mapState } from 'vuex';

export default {
    name: 'ProfileInformations',
    components: {
        navigation,
        bottom
    },
    computed: {
        ...mapState('dashboard', {
            activeTab: state => state.activeTab,
            currentUser: state => state.currentUser.uid,
            userProfile: state => state.userProfile,
            userProfileLoaded: state => state.userProfileLoaded,
        }),
        nickname: {
            get() {
                return this.$store.state.dashboard.userProfile.nickname;
            },
            set(value) {
                this.$store.commit("dashboard/setUserField", {
                    fieldToEdit: 'nickname',
                    fieldToEditValue: value,
                });
            }
        },
        hashtagN1: {
            get() {
                return this.$store.state.dashboard.userProfile.hashtags['number1'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserHashtags", {
                    hashtagToEdit: 'number1',
                    hashtagToEditValue: value,
                });
            }
        },
        hashtagN2: {
            get() {
                return this.$store.state.dashboard.userProfile.hashtags['number2'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserHashtags", {
                    hashtagToEdit: 'number2',
                    hashtagToEditValue: value,
                });
            }
        },
        hashtagN3: {
            get() {
                return this.$store.state.dashboard.userProfile.hashtags['number3'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserHashtags", {
                    hashtagToEdit: 'number3',
                    hashtagToEditValue: value,
                });
            }
        },
        phone: {
            get() {
                return this.$store.state.dashboard.userProfile.phone;
            },
            set(value) {
                this.$store.commit("dashboard/setUserField", {
                    fieldToEdit: 'phone',
                    fieldToEditValue: value,
                });
            }
        },
        about: {
            get() {
                return this.$store.state.dashboard.userProfile.about;
            },
            set(value) {
                this.$store.commit("dashboard/setUserField", {
                    fieldToEdit: 'about',
                    fieldToEditValue: value,
                });
            }
        },
        themeDark: {
            get() {
                return this.$store.state.dashboard.userProfile.preferences['preferences_dark_theme_enabled'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserPreferences", {
                    fieldToEdit: 'preferences_dark_theme_enabled',
                    fieldToEditValue: value,
                });
            }
        },
        emailPublic: {
            get() {
                return this.$store.state.dashboard.userProfile.preferences['preferences_display_publicly_email'];
            },
            set(value) {
                this.$store.commit("dashboard/setUserPreferences", {
                    fieldToEdit: 'preferences_display_publicly_email',
                    fieldToEditValue: value,
                });
            }
        },
    },
    methods: {

        saveInformations(evt) {
            evt.preventDefault();
            this.$store.dispatch('dashboard/saveUserInformations');
        },

        /**
         * Listen for avatar upload
         * If an upload is detected then we upload it to Firebase Storage
         *
         * @param event
         */
        listenForAvatarUpload(event) {
            this.uploadPercentageAvatar=0;
            this.imageData = event.target.files[0];
            imageConversion.compress(this.imageData,{
                quality: 0.8,
                type: "image/jpeg",
                width: 500,
                height: 500,
                orientation:2,
                scale: 0.5,
            }).then(res => {
                this.$store.dispatch('dashboard/onAvatarUpload', {
                    'image': res,
                    'userId': this.$store.state.user.currentUser.uid,
                });
            })
        },

        /**
         * Listen for cover upload
         * If an upload is detected then we upload it to Firebase Storage
         *
         * @param event
         */
        listenForCoverUpload(event) {
            this.uploadPercentageCover=0;
            this.imageData = event.target.files[0];
            imageConversion.compress(this.imageData,{
                quality: 0.8,
                type: "image/jpeg",
                width: 1920,
                height: 1080,
                orientation:2,
                scale: 0.5,
            }).then(res => {
                this.$store.dispatch('dashboard/onCoverUpload', {
                    'image': res,
                    'userId': this.$store.state.user.currentUser.uid,
                });
            })
        },

        /**
         * Listen for CV upload
         * If an upload is detected then we upload it to Firebase Storage
         *
         * @param event
         */
        listenForCvUpload(event) {
            this.uploadPercentageCv=0;
            this.cvFile = event.target.files[0];
            document.getElementById('cvFileLabel').innerHTML = this.cvFile.name;
            this.$store.dispatch('dashboard/onCvUpload', {
                'cvFile': this.cvFile,
                'userId': this.$store.state.user.currentUser.uid,
            });
        },

        /**
         * Delete the user's C.V
         * If the user's C.V is already uploaded, then we can delete it
         *
         * @param event
         */
        deleteUserCv(evt) {
            evt.preventDefault();
            this.$store.dispatch('dashboard/deleteUserCv', {
                'userId': this.$store.state.user.currentUser.uid,
            });
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/partials/dashboard-informations/dashboard-informations.js